import React from "react";
import CMDashboard from "../components/CMDashboard";

const CMDashboardApp = (props) => <CMDashboard {...props} />;

export default CMDashboardApp;
